// Mock data for Suno-like clone

export const COVERS = [
  'https://images.unsplash.com/photo-1711054824441-064a99073a0b?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.pexels.com/photos/4193730/pexels-photo-4193730.jpeg?auto=compress&cs=tinysrgb&w=600',
  'https://images.unsplash.com/photo-1563089145-599997674d42?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1511447333015-45b65e60f6d5?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1488554378835-f7acf46e6c98?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.pexels.com/photos/33090743/pexels-photo-33090743.jpeg?auto=compress&cs=tinysrgb&w=600',
  'https://images.pexels.com/photos/32708790/pexels-photo-32708790.jpeg?auto=compress&cs=tinysrgb&w=600',
  'https://images.unsplash.com/photo-1642744901911-89c13f549c9c?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.pexels.com/photos/5211559/pexels-photo-5211559.jpeg?auto=compress&cs=tinysrgb&w=600',
  'https://images.unsplash.com/photo-1713630019375-f483a9729a8b?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1519608487953-e999c86e7455?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1588007375246-3ee823ef4851?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.unsplash.com/photo-1533577116850-9cc66cad8a9b?crop=entropy&cs=srgb&fm=jpg&w=600&q=85',
  'https://images.pexels.com/photos/10175091/pexels-photo-10175091.jpeg?auto=compress&cs=tinysrgb&w=600',
  'https://images.pexels.com/photos/33210127/pexels-photo-33210127.jpeg?auto=compress&cs=tinysrgb&w=600',
];

// Free demo MP3s (SoundHelix - free for non-commercial demos)
export const DEMO_AUDIOS = [
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-7.mp3',
  'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3',
];

const pickAudio = (i) => DEMO_AUDIOS[i % DEMO_AUDIOS.length];
const pickCover = (i) => COVERS[i % COVERS.length];

const artists = [
  'KingDrey','Aïsha Wave','MC Voltage','Yaya Sun','Zion Roots','Lova Beats','Naima Star','Diallo','Mama Africa','RudeBoy','Selecta J','MC Fé'
];

const titles = [
  { fr: 'Nuit Lagos', en: 'Lagos Nights', genre: 'Afrobeat' },
  { fr: 'Bouge Tes Hanches', en: 'Move Your Hips', genre: 'Dancehall' },
  { fr: 'Or & Béton', en: 'Gold & Concrete', genre: 'Trap' },
  { fr: 'Sunshine Riddim', en: 'Sunshine Riddim', genre: 'Reggae' },
  { fr: 'Boulevard Sombre', en: 'Dark Boulevard', genre: 'Drill' },
  { fr: 'Kingston Lights', en: 'Kingston Lights', genre: 'Reggae' },
  { fr: 'Champion Sound', en: 'Champion Sound', genre: 'Dancehall' },
  { fr: 'Soleil Brûlant', en: 'Burning Sun', genre: 'Afro' },
  { fr: 'Block Party', en: 'Block Party', genre: 'Hip Hop' },
  { fr: 'Sister Roots', en: 'Sister Roots', genre: 'Roots Reggae' },
  { fr: 'Calle 7', en: 'Street 7', genre: 'Rap' },
  { fr: 'Bambou', en: 'Bamboo', genre: 'Afrobeat' },
  { fr: 'Joburg Piano', en: 'Joburg Piano', genre: 'Amapiano' },
  { fr: 'Log Drum Night', en: 'Log Drum Night', genre: 'Amapiano' },
  { fr: 'Port-au-Prince', en: 'Port-au-Prince', genre: 'Kompa' },
  { fr: 'Tanbou Sensuel', en: 'Sensual Drum', genre: 'Kompa' },
];

export const GENRES = ['Rap', 'Afrobeat', 'Dancehall', 'Reggae', 'Trap', 'Drill', 'Roots Reggae', 'Hip Hop', 'Afro Drill', 'Amapiano', 'Kompa'];
export const MOODS = ['Énergique', 'Chill', 'Sombre', 'Solaire', 'Romantique', 'Nostalgique', 'Festif', 'Mystique'];
export const INSTRUMENTS = [
  'Kora',
  'Flûte peule',
  'Balafon',
  'Djembé',
  'Talking drum',
  'Ngoni',
  'Sabar',
  'Mbira',
  'Marimba',
  'Calabasse',
  'Steel pan',
  'Mélodica',
  'Saxophone',
  'Guitare nylon',
  'Piano amapiano',
  'Log drum',
  'Tres cubain',
  'Tanbou kompa',
];

export const SONGS = titles.map((t, i) => ({
  id: `song_${i+1}`,
  title: t,
  genre: t.genre,
  artist: artists[i % artists.length],
  cover: pickCover(i),
  audio: pickAudio(i),
  duration: 120 + (i * 7) % 180,
  plays: 1000 + i * 1873,
  likes: 50 + i * 41,
  createdAt: new Date(Date.now() - i * 86400000).toISOString(),
  lyrics: `[Couplet 1]\nDans la nuit on brille comme l'or\nLes basses montent, on perd le décor\nKingston, Lagos, Paris, encore\nLa vibe nous porte, on a pas de remords\n\n[Refrain]\nBouge bouge bouge, sous le beat\nLove love love, sans défaite\nFais sonner, fais sonner, fais sonner\nLe son du bloc jusqu'à la fête`,
  prompt: `${t.genre} avec voix chaleureuse, basses profondes, ambiance ${i%2?'nocturne':'solaire'}`,
}));

export const PLAYLISTS = [
  { id: 'pl_1', title: { fr: 'Afro Vibes 2025', en: 'Afro Vibes 2025' }, cover: COVERS[8], count: 24 },
  { id: 'pl_2', title: { fr: 'Dancehall Heat', en: 'Dancehall Heat' }, cover: COVERS[6], count: 18 },
  { id: 'pl_3', title: { fr: 'Reggae Roots', en: 'Reggae Roots' }, cover: COVERS[13], count: 32 },
  { id: 'pl_4', title: { fr: 'Rap FR Lourd', en: 'Heavy FR Rap' }, cover: COVERS[10], count: 41 },
  { id: 'pl_5', title: { fr: 'Late Night Bounce', en: 'Late Night Bounce' }, cover: COVERS[2], count: 16 },
];

// Mock lyrics templates per genre for AI generation simulation
export const LYRICS_TEMPLATES = {
  Rap: `[Intro]\nYeah, écoute bien...\n\n[Couplet 1]\nJ'écris ma rime comme un sniper, précis\nDans la ville la nuit, j'avance sans répit\nIls parlent, ils parlent, mais le silence est d'or\nMa plume est ma vie, mon stylo c'est l'or\n\n[Refrain]\nOn s'élève, on s'élève, jamais on s'arrête\nDu béton au sommet, c'est notre conquête\nOn s'élève, on s'élève, le rêve dans la tête\nMa voix dans le mic, c'est ma seule fête`,
  Afrobeat: `[Intro]\nAfrica we rise, e be like fire\n\n[Verse 1]\nMama Africa, soleil dans mon cœur\nLagos lumière, Cotonou la chaleur\nLes tambours appellent les danseurs\nSur la piste on oublie nos pleurs\n\n[Chorus]\nWé wé wé, danse avec moi\nLove vibe, kpé kpé na\nWé wé wé, lève les bras\nAfrica forever, c'est nous, c'est ça`,
  Dancehall: `[Intro]\nSelecta pull up!\n\n[Verse]\nGyal you fine, mek mi heart a beat fast\nKingston style mi a deliver di blast\nWine slow, wine fast, wine pon di riddim\nDis a di sound dem cyaan stop di rhythm\n\n[Chorus]\nGimme di gyal dem, gimme di vibe\nDancehall a tek over, full di night\nBouge tes hanches, baby, lève le drapeau\nC'est nous les rois, on monte au plus haut`,
  Reggae: `[Intro]\nOne love, one heart...\n\n[Verse 1]\nSoleil levant sur la mer de Kingston\nRasta heart, jamais on plie le ton\nJah guide nos pas sur le chemin de l'amour\nDe Marley à nous, c'est le même tambour\n\n[Chorus]\nOne love, one vibe, sous le même ciel\nReggae forever, c'est éternel\nOn marche ensemble, frères et sœurs\nLa musique guérit toutes les douleurs`,
  Amapiano: `[Intro]\nLog drum dey roll, piano dey sing...\n\n[Verse]\nJoburg by night, on glisse sur le beat\nLe shaker chuchote, la kick fait suite\nNos cœurs en cadence sur le tempo doux\nL'amapiano nous porte, on est partout\n\n[Chorus]\nLog drum, log drum, lève-toi danse\nPiano keys nous donnent la chance\nWoza woza, on tient la nuit\nL'Afrique du Sud à l'infini`,
  Kompa: `[Intro]\nKonpa direk, mete kè ou nan rit...\n\n[Couplet 1]\nSous la lune d'Haïti, danse collé serré\nLa guitare appelle, je ne peux résister\nKonpa nan san mwen, c'est plus fort que moi\nViens, on s'enlace, oublie ton émoi\n\n[Refrain]\nDoucement, doucement, sur le tanbou\nKompa pou la vi, sé sa nou bezwen tout\nTes hanches parlent, mes mains répondent\nLa nuit nous emporte, le monde s'estompe`,
};

export const PROFILE = {
  name: 'Mon Studio',
  email: 'demo@studio.app',
  credits: 120,
  plan: 'Free',
};
